import {
   getAdSetsLoading,
   getAdSetsSuccess,
   getAdSetsFailure,
   createAdSetLoading,
   createAdSetSuccess,
   createAdSetFailure,
} from "@redux/slices/adSetsSlice.js"
import {
   getAllAdSetsLoading,
   getAllAdSetsSuccess,
   getAllAdSetsFailure,
} from "@redux/slices/allAdSetsSlice.js"

import { useDispatch } from "react-redux"
import { getAdSetByCampaignId } from "@services/adsets/getAdSetByCampaignId.js"
import { getAllAdSetsByAccountId } from "@services/adsets/getAllAdSetsByAccountId.js"
import { dumbDuplicateAdset, updateAdset, getAdsetDetails } from "@services/adsets/duplicateAdSet.js"

const useAdSets = () => {
   const dispatch = useDispatch()

   const handleGetAdSets = async (campaignId) => {
      try {
         if (!campaignId) return
         dispatch(getAdSetsLoading())
         const response = await getAdSetByCampaignId(campaignId)
         // console.log("response", response)
         dispatch(getAdSetsSuccess(response.data))
      } catch (error) {
         dispatch(getAdSetsFailure(error.message || 'Failed to fetch ad sets'))
         console.log(error)
      }
   }

   const handleGetAllAdSets = async (adAccountId) => {
      try {
         console.log("get adsets for adAccountId", adAccountId)
         dispatch(getAllAdSetsLoading())
         const response = await getAllAdSetsByAccountId(adAccountId)
         dispatch(getAllAdSetsSuccess(response.data))
      } catch (error) {
         dispatch(getAllAdSetsFailure())
         console.log(error)
      }
   }

   const getTragetingDetailsFromAdSet = async (adSetId) => {
      // fetch adset details from api
      try {
         const response = await getAdsetDetails(adSetId)
         // console.log("adset details response", response)
         const targeting = response.data.targeting
         return targeting
      } catch (error) {
         console.log("Error fetching ad set targeting details:", error)
         return null
      }
   }

   const repairAdsetTargeting = async (adSetId, originalTargetingDetails) => {
      // check for a field "age_range" in the originalTargetingDetails, this is not allowed by facebook
      // if it is present, then remove the field "age_range" from the originalTargetingDetails
      // and update the adset with the new targeting details

      if (originalTargetingDetails.age_range) {
         delete originalTargetingDetails.age_range
         // update the adset with the new targeting details
         try {
            const response = await updateAdset(adSetId, { targeting: originalTargetingDetails })
            console.log("adset updated with new targeting details", response)
            return true
         } catch (error) {
            console.log("Error updating ad set targeting:", error)
         }
      }
      else {
         console.log("No need to repair targeting details")
         return false
      }
      
   }

   const handleCheckAndRepairAdSetTargeting = async (adSetId) => {
      // get the original targeting details from the adset
      const originalTargetingDetails = await getTragetingDetailsFromAdSet(adSetId)
               
      // repair the targeting details
      const isRepaired = await repairAdsetTargeting(adSetId, originalTargetingDetails)

      // check if the adset is repaired
      if (isRepaired) {
         console.log("Adset targeting details repaired successfully")
      } else {
         console.log("Adset targeting details not repaired")
      }
      return isRepaired
   }

   const handleDuplicateAdSet = async (adSetData) => {
      try {
         dispatch(createAdSetLoading())
         const response = await dumbDuplicateAdset(adSetData.originalAdSetId, adSetData.targetCampaign.id)
         // console.log("response from duplicate Adset:", response)
         const duplicateAdSetId = response.data.copied_adset_id
         let updateData = {
            name: adSetData.duplicateAdSetName,
            status: adSetData.duplicateAdSetStatus
         }
         if (!adSetData.targetCampaign.daily_budget) {
            updateData.daily_budget = adSetData.dailyBudget * 100
         }
         const updateResponse = await updateAdset(duplicateAdSetId, updateData)
         // console.log("response from updateAdset:", updateResponse)
         dispatch(createAdSetSuccess(updateResponse.data))
         return updateResponse.data
      } catch (error) {
         dispatch(createAdSetFailure())
         console.log(error)
         throw error
      }
   }

   const handleDuplicateAdSetForAdPerAdset = async (referenceAdSetId, newAdSetName) => {
      try {
         dispatch(createAdSetLoading())
         const response = await dumbDuplicateAdset(referenceAdSetId)
         const duplicateAdSetId = response.data.copied_adset_id

         const updateData = {
            name: newAdSetName,
         }
         const updateResponse = await updateAdset(duplicateAdSetId, updateData)
         dispatch(createAdSetSuccess(updateResponse.data))
         return duplicateAdSetId
      } catch (error) {
         dispatch(createAdSetFailure())
         console.log(error)
         throw error
      }

   }

   return { handleGetAdSets, handleGetAllAdSets, handleDuplicateAdSet, handleDuplicateAdSetForAdPerAdset, handleCheckAndRepairAdSetTargeting }
}

export default useAdSets
